import { cn as classname } from '@bem-react/classname';

export const cn = classname('KhErrorState');
